import { useEffect, useState } from 'react';
import { useMinicrmMigrationStore } from '../../../store/minicrmMigrationStore';
import { ProposalTable } from './ProposalTable';

export function ContactsTab() {
  const { contacts, fetchContacts } = useMinicrmMigrationStore();
  const [action, setAction] = useState<string>('');
  const [blocked, setBlocked] = useState(false);
  const [page, setPage] = useState(1);

  useEffect(() => { fetchContacts({ action: action || undefined, blocked }, page); }, [fetchContacts, action, blocked, page]);

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3 text-sm">
        <select className="border rounded px-2 py-1" value={action} onChange={(e) => { setPage(1); setAction(e.target.value); }}>
          <option value="">All actions</option>
          <option value="AUTO_LINK">Auto-link</option>
          <option value="AUTO_CREATE">Auto-create</option>
          <option value="SKIP">Skip</option>
        </select>
        <label className="flex items-center gap-1"><input type="checkbox" checked={blocked} onChange={(e) => { setPage(1); setBlocked(e.target.checked); }} /> Blocked only</label>
      </div>
      {contacts && (
        <>
          <ProposalTable proposals={contacts.contacts} onChanged={() => fetchContacts({ action: action || undefined, blocked }, page)} />
          <div className="flex items-center justify-between text-xs text-gray-500">
            <span>{contacts.pagination.total} contacts · page {contacts.pagination.page} / {contacts.pagination.pages || 1}</span>
            <div className="flex gap-2">
              <button type="button" className="px-2 py-1 border rounded disabled:opacity-40" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>Prev</button>
              <button type="button" className="px-2 py-1 border rounded disabled:opacity-40" disabled={page >= contacts.pagination.pages} onClick={() => setPage((p) => p + 1)}>Next</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
